"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var counter = {};
function uid(prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (typeof counter[prefix] === 'undefined') {
        counter[prefix] = 0;
    }
    counter[prefix] += 1;
    return (prefix || 'ndsElem') + "_" + counter[prefix];
}
exports.default = uid;
//# sourceMappingURL=uid.js.map